import { makeStyles } from "@material-ui/core/styles";

export function useModalExcludeStyles() {
    const useStyles = makeStyles((theme) => ({
        button: {
            color: "#004B97",
            fontSize: "0.95rem",
            padding: "0.5rem 1rem",
            "&:hover": {
                backgroundColor: "transparent",
            },
        },
        cancelButton: {
            color: theme.palette.primary.main,
            fontSize: theme.typography.pxToRem(14),
        },
        cardHeader: {
            color: "#FFF",
            backgroundColor: "#004B97",
        },
        cardContent: {
            display: "flex",
            flexDirection: "column",
            minWidth: 600,
        },
        cardActions: {
            justifyContent: "flex-end",
            borderTop: "1px solid #F0F0F0",
        },
        textWarning: {
            fontSize: "1rem",
            fontWeight: 400,
        },
        deleteButton: {
            color: "#FFF",
            padding: "0.5rem 1rem",
            fontSize: "0.95rem",
            backgroundColor: "#E22323",
            "&:hover": {
                backgroundColor: "#B21C1C",
            },
        },
    }));

    const classes = useStyles();

    return {
        classes,
    };
}
